import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/tvSeries';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-movie-2-line text-xl text-primary-500"></i>
              </div>
              <span className="text-lg font-bold font-heading text-foreground-900">{siteInfo.name}</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {siteInfo.slogan}<br />
              为您提供最新最全的电视剧资源
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">剧集分类</h4>
            <div className="flex flex-col gap-2">
              {categories.filter(c => c.slug !== 'all').slice(0, 4).map(cat => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">更多分类</h4>
            <div className="flex flex-col gap-2">
              {categories.filter(c => c.slug !== 'all').slice(4).map(cat => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">关于我们</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">
                品牌介绍
              </Link>
              <a href="mailto:contact@caomin.tv" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">
                联系我们
              </a>
              <span className="text-sm text-foreground-500">
                &copy; {new Date().getFullYear()} {siteInfo.name}
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有
          </p>
          <p className="text-xs text-foreground-500">
            本站内容仅供学习交流，请勿用于商业用途
          </p>
        </div>
      </div>
    </footer>
  );
}